// extracted by mini-css-extract-plugin
module.exports = {"pricing":"index-module--pricing--3ZuCI Box-module--box--X0EGm"};